<template>
  <figure class="absolute inset-0">
    <picture>
      <source media="(min-width: 1536px)" :srcSet="src" />
      <source media="(min-width: 1280px)" :srcSet="getSizedImage(src, 1536)" />
      <source media="(min-width: 1024px)" :srcSet="getSizedImage(src, 1280)" />
      <source media="(min-width: 768px)" :srcSet="getSizedImage(src, 1024)" />
      <source media="(min-width: 640px)" :srcSet="getSizedImage(src, 768)" />
      <img
        :src="getSizedImage(src, 640)"
        class="object-cover object-center size-full"
        alt="background"
      />
    </picture>
  </figure>
</template>

<script setup lang="ts">
  import { getSizedImage } from '@/utils/image';

  interface Props {
    src: string;
  }

  defineProps<Props>();
</script>
